module.exports = __webpack_public_path__ + "media/images/emblems/Geuensee_LU-282c39b0af6ea2ec59a36bb86db46b5d.png";